// Copyright 2025, University of Maryland, All Rights Reserved
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'
import { setupLocalAuth } from './app-shell/dev/local-auth'
import { restoreBoxOAuthCallbackRoute } from './subsystems/vault/connectors/box/services/box-session'

// cm-coding: CAS can replace the Box OAuth callback URL before React mounts.
// Restore the signed-in route first so BrowserRouter handles the intended Vault
// callback rather than rendering and persisting the transient CAS location.
restoreBoxOAuthCallbackRoute()

// Debug log to check environment variables
console.log('[DEBUG] Environment Variables:', {
  apiUrl: import.meta.env.VITE_API_URL,
  jobsApiUrl: import.meta.env.VITE_JOBS_API_URL,
  debugMode: import.meta.env.VITE_DEBUG_MODE,
  mode: import.meta.env.MODE,
  base: import.meta.env.BASE_URL,
})

// Setup local auth (no-op in production), then render app
setupLocalAuth().then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>
  )
})
